import React from 'react';
import { breakfastHighlights, images } from '../data/site';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
export function Breakfast() {
  return <section id="breakfast" className="w-full bg-sand-light" data-id="element-25" data-mp="7dvayybszvg4">
      <div className="grid lg:grid-cols-2" data-id="element-26" data-mp="7cahlc186iju">
        <Reveal className="order-2 flex items-center px-5 py-20 sm:px-8 sm:py-24 lg:order-1 lg:px-16 lg:py-32 xl:px-24" data-id="element-27" data-mp="c4tt83gcr3m0">
          <div className="max-w-xl" data-id="element-28" data-mp="g4vmbo80uopo">
            <SectionLabel data-id="element-29" data-mp="g7zxx6ntgmqd">Breakfast Included</SectionLabel>
            <h2 className="mt-6 font-serif text-[clamp(2rem,4.5vw,3.5rem)] font-light leading-[1.08] text-forest-deep" data-id="element-30" data-mp="l3yrr9rwywy6">
              Start your day
              <span className="block italic text-ocean" data-id="element-31" data-mp="q28ovpx787mf">in Taveuni</span>
            </h2>
            <p className="mt-7 text-[17px] leading-[1.85] text-forest-deep/70" data-id="element-32" data-mp="v13epbtl2wg1">
              Enjoy a fresh homemade breakfast prepared with local ingredients
              before heading out to explore the island.
            </p>

            <ul className="mt-10 flex flex-wrap gap-2.5" data-id="element-33" data-mp="bcuvax3k7yxh">
              {breakfastHighlights.map(item => <li key={item} className="rounded-full border border-gold/40 bg-ivory px-5 py-2.5 text-[11px] font-medium uppercase tracking-[0.14em] text-forest-deep/75 transition-colors duration-300 hover:border-gold hover:text-forest-deep" data-id="element-34" data-mp="6m4nzebkpm05">
                  {item}
                </li>)}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={0.1} className="order-1 lg:order-2" data-id="element-35" data-mp="pcmav29q5ndl">
          <div className="h-full overflow-hidden" data-id="element-36" data-mp="kdsyxea364fj">
            <img src={images.breakfast} alt="A homemade tropical breakfast of fresh fruit, eggs, bread and coffee" loading="lazy" className="h-[340px] w-full object-cover transition-transform duration-[1400ms] ease-calm hover:scale-[1.05] sm:h-[480px] lg:h-full lg:min-h-[640px]" data-id="element-37" data-mp="kchv5egn4wof" />
          </div>
        </Reveal>
      </div>
    </section>;
}